// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S_mm","delete":"styles_delete__2-zUG","update":"styles_update__ahqDP","add":"styles_add__3T-h9"};